import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';

// Material-ui
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import CircularProgress from '@material-ui/core/CircularProgress';

// Utilities and helpers
import { get, signin, auth } from './_api/api';

const useStyles = makeStyles(theme => ({
    container: {
        [theme.breakpoints.up('xs')]: {
            minWidth: '440px',
            width: '440px',
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    root: {
        marginTop: theme.spacing(12),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
    },
    submit: {
        margin: theme.spacing(1, 0, 2),
    },
    logo: {
        height: '40px',
        margin: theme.spacing(3, 0, 2),
    },
    progressbutton: {
        position: 'relative',
        width: '100%',
    },
    progress: {
        color: theme.palette.background.paper,
        position: 'absolute',
        top: '50%',
        left: '30%',
        marginTop: -8,
        marginLeft: -8,
    },
    contactInfo: {
        margin: theme.spacing(2, 0, 0),
    }
}));

const Login = () => {
    const classes = useStyles();
    const [credentials, setCredentials] = useState({}); // Credentials of the user that is logging in
    const [state, setState] = useState({
        fetching: false,
        fetched: false,
        fetchError: false,
        message: null
    });

    const handleChange = (event) => {
        setState(prevState => { return { ...prevState, fetching: false, fetched: false, fetchError: false, message: null } })
        setCredentials({ ...credentials, [event.target.name]: event.target.value });
    }

    const getValue = (name) => credentials[name] || '';

    // This function is called when the user clicks on SignIn
    const signInUser = () => {
        setState(prevState => { return { ...prevState, fetching: true } })

        auth() // First authorise the channel
            .then(response => {
                localStorage.setItem('clientauth', JSON.stringify(response));
                signin(credentials, response.access_token) // Sign-In the user
                    .then(response => {
                        localStorage.setItem('userauth', JSON.stringify(response));
                        get('/Member/info', response.access_token) // Get the info of the user, we will need it later
                            .then(response => {
                                if (response.Data.UserType === 4) {
                                    localStorage.setItem('bw-member', JSON.stringify(response.Data));
                                    setState(prevState => { return { ...prevState, fetched: true, fetching: false, fetchError: false, message: null } })
                                }
                                else
                                    setState(prevState => { return { ...prevState, fetching: false, fetchError: true, message: 'Unauthorised user' } })
                            })
                            .catch(error => setState(prevState => { return { ...prevState, fetching: false, fetchError: true, message: error.message } }));
                    })
                    .catch(error => setState(prevState => { return { ...prevState, fetching: false, fetchError: true, message: error.message } }));
            })
            .catch(error => setState(prevState => { return { ...prevState, fetching: false, fetchError: true, message: error.message } }));
    }

    if (state.fetched) return <Redirect to='/wellcome' /> // If the member is signed in successfuly, redirect to Home Page

    return (
        <Container className={classes.container}>
            <CssBaseline />
            <div className={classes.root}>
                <img className={classes.logo} alt='BrandWallet Logo' src='assets/img/bw-logo-color-250x50.png' />
                <Typography>Leading Mobile Wallet Loyalty Solutions!</Typography>
                <TextField fullWidth margin='normal' id='Username' label='Username' name='Username' onChange={handleChange} value={getValue('Username')} variant='outlined'
                    error={!!state.fetchError} />
                <TextField fullWidth margin='normal' id='Password' label='Password' name='Password' onChange={handleChange} value={getValue('Password')} variant='outlined' type='password'
                    onKeyDown={e => e.key === 'Enter' ? signInUser(e) : () => { }}
                    helperText={state.message || ' '}
                    error={!!state.fetchError} />
                <div className={classes.progressbutton}>
                    <Button className={classes.submit} fullWidth size='large' variant='contained' color='primary' onClick={signInUser} disabled={state.fetching}>SIGN IN</Button>
                    {state.fetching && <CircularProgress size={24} className={classes.progress} />}
                </div>
                <Typography color='primary' variant='caption'>
                   If you don't have a BrandWallet account, <Link target='blank' underline='always' href='https://www.brand-wallet.com#footer'>please connect us through our website</Link> or <Link target='blank' underline='always' href='https://api.whatsapp.com/send?phone=971585521106'>Whatsapp.</Link>
                </Typography>
                <Typography className={classes.contactInfo} color='primary' variant='caption'>
                +971 58 552 1106 - <Link target='blank' href='https://www.brand-wallet.com'>www.brand-wallet.com</Link>
                </Typography>
            </div>
        </ Container>
    );
}

export default Login;